import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { DeployParams } from 'src/app/deployParams';
import { TicketFilterStatus, TicketStatus } from 'src/app/models/enums';
import { IPlayedTicket } from 'src/app/models/ticket/playedTicket';
import { CashOutService } from 'src/app/services/cash-out.service';
import { TicketService } from 'src/app/services/ticket.service';
import { UserService } from 'src/app/services/user.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { MyTicketComponent } from '../../ticket/my-ticket/my-ticket.component';
const maxDateSpanDays = 31.5;
const ticketsPerPage = 10;

@Component({
  selector: 'app-my-tickets-mobile',
  templateUrl: './my-tickets-mobile.component.html',
  styleUrls: ['./../../ticket/my-ticket/my-ticket.component.less']
})
export class MyTicketsMobileComponent extends MyTicketComponent implements AfterViewInit, OnDestroy {

  public myTickets: IPlayedTicket[] = [];
  private ticketsFilterString = null;

  maxDate: Date = new Date();
  minDate: Date = new Date();

  public allTicketsLoaded = false;
  public isLoadingMoreTickets = true;
  constructor(
    protected userService: UserService,
    protected ticketService: TicketService,
    protected cashOutService: CashOutService,
    protected utilityService: UtilityService,
    protected storageService: StorageService,
    protected authService: AuthenticationService) {
    super(userService, ticketService, cashOutService, utilityService, storageService, authService);
  }
  // @Output()
  // closeMobileTicket: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngAfterViewInit() {
    window.addEventListener('scroll', this.scroll, true); // third parameter

    // let day = 30;
    this.setMinDateDay(maxDateSpanDays);

    // this.sr = {
    //     firstDayOfWeek: 1,
    //     dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
    //     dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
    //     dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
    //     monthNames: ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
    //     monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec']
    // };
  }

  changeTicketsFilter(status: TicketFilterStatus) {
    if (this.ticketsFilterStatus !== status) {
      this.ticketsFilterStatus = status;
      this.ticketsFilterString = this.utilityService.getTicketFilterString(this.ticketsFilterStatus);
      this.myTickets = [];
      this.allTicketsLoaded = false;
      this.getMyTicketsMobile();
    }
  }

  dateFromChanged(event) {
    const dateFrom = event.value;
    const offset = dateFrom.getTimezoneOffset();
    if (dateFrom === this.dateFrom) {
      return;
    }
    this.dateFrom = dateFrom;

    const diff = (this.dateTo.getTime() - this.dateFrom.getTime()) / (1000 * 60 * 60 * 24);
    if (diff > maxDateSpanDays || diff <= 0) {
      const date = new Date();
      date.setFullYear(this.dateFrom.getFullYear());
      date.setMonth(this.dateFrom.getMonth());
      date.setDate(this.dateFrom.getDate() + 29);
      date.setHours(23, 59, 59, 999);

      if (date > this.maxDate) {
        this.dateTo = this.maxDate;
      } else {
        this.dateTo = date;
      }
    }

    this.getMyTicketsMobile();
  }

  dateToChanged(event) {
    const dateTo: Date = event.value;
    const offsetUtc = dateTo.getTimezoneOffset();
    dateTo.setHours(23, 59, 59, 999);
    if (dateTo === this.dateTo) {
      return;
    }
    this.dateTo = dateTo;
    const diff = (this.dateTo.getTime() - this.dateFrom.getTime()) / (1000 * 60 * 60 * 24);
    if (diff > maxDateSpanDays || diff <= 0) {
      const date = new Date();
      date.setFullYear(this.dateTo.getFullYear());
      date.setMonth(this.dateTo.getMonth());
      date.setDate(this.dateTo.getDate() - 29);
      date.setHours(0, 0, 0, 0);

      this.dateFrom = date;
    }

    this.getMyTicketsMobile();
  }

  scroll = (event): void => {
    const move = 200;
    // console.log(event.target.className);
    // console.log(event.target.classList.contains('ticket-body-wrap'));

    if (event.target.id === 'ticketMainWrap') {
      // console.log(event);
      // console.log(event.target.scrollTop);

      if ((event.target.clientHeight + event.target.scrollTop + move) >= event.target.scrollHeight) {
        // console.log('load new content');
        if (this.myTickets.length >= ticketsPerPage && !this.allTicketsLoaded && !this.isLoadingMoreTickets) {
          this.isLoadingMoreTickets = true;
          this.getMyTicketsMobile(false);
        }
      }

      if ((event.target.clientHeight + event.target.scrollTop) >= event.target.scrollHeight) {
        // console.log('end reached');

      }

    }
  }

  resetFilters() {
    this.dateTo = new Date();
    this.dateFrom = new Date();
    this.dateTo.setHours(23, 59, 59, 999);
    this.dateFrom.setFullYear(this.dateTo.getFullYear());
    this.dateFrom.setMonth(this.dateTo.getMonth());
    this.dateFrom.setDate(this.dateTo.getDate() - 29);
    this.dateFrom.setHours(0, 0, 0, 0);
    this.maxDate.setHours(23, 59, 59, 999);
    this.ticketsFilterStatus = TicketFilterStatus.All;
    this.allTicketsLoaded = false;
    this.ticketsFilterString = this.utilityService.getTicketFilterString(this.ticketsFilterStatus);
  }

  // closeTicketForMobile() {
  //     this.closeMobileTicket.emit(true);
  // }

  getMyTicketsMobile(resetFilters: boolean = true) {
    if (!this.isUsserLogged) {
      this.isLoadingMoreTickets = false;
      return;
    }

    if (resetFilters) {
      this.myTickets = [];
      this.allTicketsLoaded = false;
    }
    const token = this.storageService.affiliateJwtToken ? this.storageService.affiliateJwtToken : this.userService.user.userSBToken;
    this.ticketService.getTicketsForMobile(
      token,
      ticketsPerPage,
      this.myTickets.length,
      this.dateFrom,
      this.dateTo,
      this.ticketsFilterString).subscribe(tickets => {
        // for (const ticket of tickets) {
        //   if (ticket.status.code === TicketStatus.Pending) {
        //     if (this.cashOutTimer == null) {
        //       this.cashOutTimer = timer(0, 15000);
        //       this.cashOutTimerSub = this.cashOutTimer.subscribe(t => this.updateCashBackValue(t));
        //     }
        //   }
        // }

        this.myTickets = this.myTickets.concat(tickets);
        if (tickets.length < ticketsPerPage) {
          this.allTicketsLoaded = true;
        }
        this.isLoadingMoreTickets = false;
      }, err => {
        if (err.status === 401) {
          this.isLoadingMoreTickets = false;
        }
      });
  }

  updateCashBackValue(timerTick: any): void {
    this.myTickets.forEach(playedTicket => {
      if (playedTicket.status.code === TicketStatus.Pending) {
        this.cashOutService.updateCashOutValue(playedTicket);
      }
    });
  }

  updateCashedOutTicket(cashedOutTicketId: number) {
    if (this.ticketsFilterStatus !== TicketFilterStatus.All) {
      this.myTickets.splice(this.myTickets.findIndex(t => t.id === cashedOutTicketId), 1);
    } else {
      const ticket = this.myTickets.find(t => t.id === cashedOutTicketId);
      if (ticket) {
        ticket.cashoutValue = null;
        ticket.possibleMaxWin = ticket.cashoutValue;
        ticket.status.code = TicketStatus.CashOut;
      }
    }
  }

  setMinDateDay(day) {
    this.minDate.setDate(this.maxDate.getDate() - day);
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
    this.cashOutTimer = null;
    if (this.cashOutTimerSub) {
      this.cashOutTimerSub.unsubscribe();
    }
    if (this.lastFiveTimer) {
      this.lastFiveTimer = null;
    }
    if (this.lastFiveTimerSub) {
      this.lastFiveTimerSub.unsubscribe();
    }
  }
}
